import React, { useEffect, useRef, useState} from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { signUp } from "../../actions/session/signUp";
import Toast from "../global/Toast";
import SpinnerButton from "../global/SpinnerButton";
import roleData from "../../assets/data/teams_roles.json";
import { asyncLocalStorage } from "../global/msal/setSsoLocalStorage";
import { toastMessage } from "../../actions/toast";
import { useAuthFetch } from "../global/hooks/sso/useAuthFetch";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';


const SignUp = (props) => {
  const location = useLocation();
  let navigate = useNavigate();
  const passwordValidationRef = useRef(null);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [loadingState, setLoadingState] = useState(false);
  const [teamSelected, setTeamSelected] = useState(null);

  // Set incoming values for sso only login redirect
  const [firstName, setFirstName] = useState(
    location.state ? location.state.user.firstName : null
  );
  const [lastName, setLastName] = useState(
    location.state ? location.state.user.lastName : null
  );
  const [email, setEmail] = useState(
    location.state ? location.state.user.email : null
  );

  const [isSsoLogin, setIsSsoLogin] = useState(false);

  /**************************************
   * honeyPot: Use to prevent BOT Spam attacks
   ***************************************/
  const honeypotRef = useRef(null);
  const [isHoneypotFilled, setIsHoneypotFilled] = useState(false);

  const selectFields = "displayName,mail,jobTitle,userPrincipalName,department";
  const configName = "graphUsers";

  const userRequest = {
    msGraphName: configName,
    email,
    fields: selectFields,
  };

  const [userProfile] = useAuthFetch(userRequest);
  // Sanitize input values
  const sanitizeInput = (input) => {
    return input.replace(/(<([^>]+)>)/gi, "");
  };

  /**
   * startUserSignUp: Create an sso
   * or native user base on isSsoLogin
   *
   * signUp(user): Determine
   * if LoginType is SSO
   *  or Native Login
   **/
  /**********************/
  const startUserSignUp = (user) => {
    console.log('68')
    props.signUp(user).then(async (response) => {
      // console.log("SignUp callback: response:", response);
      let data;
      if (response) {
        data = await response.json();
        data.status = response.status;
        // console.log("SignUp Data:", data);
      } else {
        // console.log("SignUp: No response received", response)
        return;
      }
      setLoadingState(false);
      if (data.status === 200) {
        console.log('82', data)
        props.toastMessage(data.message.message ? data.message.message : data.message);
        setTimeout(() => {
          navigate("/sign-in");
          // we should  to sso if ssoLogin
          //  navigate("/sso", { state: data.status });
        }, 3000);
      } else {
        console.log('90', data)
        props.toastMessage(data.message.message ? data.message.message : data.message);
      }
    });
  };
  /**
   * ssoRole - location.state on SignUp contains the
   * final sso role.  SingleSignIn passed the role
   * from SignIn
   * */
  // console.log("location.state.user:", location?.state?.user?.ssoRole, location?.state?.user?.role, "isSsoLogin:", isSsoLogin)
  const [ssoRole, setSsoRole] = useState(
     location.state && location.state.user && location.state.user.role
      ? location.state.user.role
      : "guest"
  );

  useEffect(() => {
    // console.log("On Page Load:", isSsoLogin);
    asyncLocalStorage.getItem("endeavor-sso").then((ssoLogin) => {
      // console.log("SSOLOGIN:", ssoLogin);
      setIsSsoLogin(ssoLogin);
      // console.log("isSsoLogin:", isSsoLogin);
    });
  }, []);

  useEffect(() => {
    if (isSsoLogin && userProfile) {
      // console.log("Signup: userProfile", userProfile);
      let ssoDepartmentMembers = userProfile.departmentMembers?.value?.map(
        (item) => item["mail"].toLowerCase().trim()
      );
      ssoDepartmentMembers.push(
        userProfile.mail.toLowerCase().trim(),
        userProfile.manager.userPrincipalName.toLowerCase().trim()
      );
      // console.log("SSOROLE:", ssoRole)
      const ssoUser = {
        firstName,
        lastName,
        team: userProfile.department,
        role: userProfile.jobTitle,
        email,
        password: "sso",
        ssoRole,
        ssoDepartmentMembers,
        ssoIsManager: userProfile.isManager,
        ssoManager: userProfile.manager.userPrincipalName.toLowerCase().trim(),
        ssoDirectReports: userProfile.directReports?.value?.map((item) =>
          item["mail"].toLowerCase().trim()
        ),
      };
      // start startUserSession
      // console.log(
      //   "******SignUp: Auto Launch HandleSubmit for SSO User: isSsoLogin:",
      //   isSsoLogin
      // );

      startUserSignUp(ssoUser);
    }
  }, [userProfile, ssoRole, isSsoLogin]);

  const handleSubmit = async (event) => {
    console.log('149')
    event.preventDefault();
    
    /*******************************
     * Check if honeypot field is filled
     * ******************************/
    if (honeypotRef.current.value !== "") {
      // Honeypot field is filled, likely a bot
      console.log("Bot detected!", honeypotRef.current.value);

      return;
    }
      /************************* */
          // Execute reCAPTCHA when form is submitted
      const token = await executeRecaptcha('signup');
    console.log('the token', token)
    setRecaptchaToken(token);

    if (!token) {
      // reCAPTCHA failed, handle appropriately
      return;
    }
    //check if passwords match
    // console.log(event.target[6].value, event.target[7].value )
    if (event.target[6].value !== event.target[7].value) {
      passwordValidationRef.current.style.display = "block";
    } else {
      setLoadingState(true);
      const nativeUser = {
        firstName: sanitizeInput(event.target[0].value),
        lastName: sanitizeInput(event.target[1].value),
        team: sanitizeInput(event.target[2].value),
        role: sanitizeInput(event.target[3].value),
        email: sanitizeInput(event.target[4].value),
        honeypot: sanitizeInput(event.target[5].value),
        password: sanitizeInput(event.target[6].value),
        ssoRole,
      };
      /**
       * Create either sso or native user
       */
      const userWithRecaptcha = {
        ...nativeUser,
        token
      };
      console.log(userWithRecaptcha)
      startUserSignUp(userWithRecaptcha);
    }
  };
  /***************/
  /**
   * setTeamSelected - Sets the team Selected
   * @param {*} team
   */
  const handleSelectTeam = (team) => {
    setTeamSelected(team);
  };

  /**
   * handleGetRoles - Populates roles element with
   * team roles based on team selection
   * @returns
   */
  const handleGetRoles = () => {
    let roles = [];
    roleData.teams.forEach((team, i) => {
      if (team.name === teamSelected) {
        team.roles.forEach((role, i) => {
          roles.push(
            <option key={i} value={role}>
              {role}
            </option>
          );
        });
      }
    });
    return roles;
  };

  return (
  <>
      <Toast />
      {!isSsoLogin ? (
        <div className="auth-page">
          <div className="card sign-up-card">
            <form
              onSubmit={(event) => {
                event.stopPropagation();
                handleSubmit(event);
              }}
            >
              <h5 className="text-start">
                <svg
                  className="logo"
                  width="53"
                  height="54"
                  viewBox="0 0 53 54"
                  fill="white"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M47.3645 39.3043C55.7786 24.5552 52.9631 9.97881 40.8713 3.47723C27.5109 -3.70834 10.0933 0.201245 2.58525 15.5912C-2.58606 26.1878 -0.237896 44.6035 11.7948 51.2059C23.8256 57.8047 39.9709 52.2679 47.3645 39.3043ZM43.279 23.6316C43.6892 20.6634 42.9529 17.0455 40.5856 14.6605L40.5513 14.6281C36.0037 9.78067 29.6898 9.47647 25.6916 9.57007C21.2719 9.67627 18.0977 11.0533 15.5016 12.3313C13.2354 13.4455 11.1925 15.3625 10.3627 16.3147C9.83431 16.9213 8.93587 18.1741 9.41847 19.2973C9.81524 20.2296 11.305 20.1684 11.8658 19.7706C12.1611 19.5605 12.466 19.2925 12.8013 18.9978C13.1006 18.7348 13.4241 18.4504 13.7867 18.1669C17.1993 15.5029 20.2246 13.8253 27.2729 13.8253C34.3213 13.8253 38.1401 17.9725 38.1401 21.675C38.1401 25.3776 36.286 27.8922 32.7819 29.5338C31.0479 30.3456 29.1938 30.9738 26.859 31.0584C27.0288 27.4692 27.1165 24.0726 27.1165 24.0726C27.1247 23.6472 27.1441 23.2349 27.1626 22.8413C27.2565 20.8448 27.3278 19.33 25.7965 19.0399C23.9672 18.6925 20.5966 19.0345 20.5336 21.0054C20.4516 20.712 20.8808 37.1568 20.959 37.4808L20.9895 37.8588C21.0258 38.2764 21.1822 38.6436 21.4588 38.937C21.7354 39.2268 22.1837 39.4068 22.5862 39.45C22.6491 39.4554 22.7121 39.4608 22.775 39.4608C23.1584 39.4608 23.6982 39.396 24.2419 39.252C24.9286 39.0666 25.6191 38.7516 26.0178 38.2602C26.22 38.0118 26.386 37.7706 26.4718 37.326C26.5309 37.0236 26.6473 35.1138 26.6778 34.5594C30.3841 34.527 34.1515 33.8718 37.0185 32.223C40.6333 30.1476 42.8079 27.0156 43.279 23.6316ZM24.1007 41.3544C24.5185 41.4318 24.9305 41.6172 25.2987 41.8872H25.2987C25.9663 42.3768 26.367 43.1418 26.3745 43.9248C26.3803 44.5998 26.0808 45.2028 25.5295 45.6294C25.0545 45.9894 24.4441 46.1838 23.765 46.1838H23.7631C23.4522 46.1838 23.1412 46.1406 22.8379 46.0614C22.3115 45.9192 21.888 45.6834 21.6114 45.3774C21.3634 45.1056 21.1975 44.7402 21.125 44.3172C21.0143 43.6584 21.1879 42.9762 21.6076 42.4074C22.1112 41.7216 22.8837 41.313 23.6696 41.313C23.8127 41.313 23.9596 41.3274 24.1007 41.3544Z"
                  />
                </svg>
                <span>Sign up</span>
              </h5>
              <div className="form-group text-start">
                <label>First name</label>
                <input
                  className="form-control card-input"
                  placeholder="Enter your First name"
                  type="text"
                  required
                  defaultValue={firstName}
                  name="firstName"
                />
              </div>
              <div className="form-group text-start">
                <label>Last name</label>
                <input
                  className="form-control card-input"
                  placeholder="Enter your Last name"
                  type="text"
                  required
                  defaultValue={lastName}
                  name="lastName"
                />
              </div>
              <div className="form-group text-start">
                <label>Team</label>
                <select
                  name="team"
                  className="form-control card-input select"
                  required
                  defaultValue=""
                  onChange={(event) => {
                    handleSelectTeam(event.target.value);
                  }}
                >
                  <option disabled value="">
                    {" "}
                    -- select an option --{" "}
                  </option>
                  {roleData.teams.map((team, i) => {
                    return (
                      <option key={i} data-index={i} value={team.name}>
                        {team.name}
                      </option>
                    );
                  })}
                </select>
                <span className="select2-selection__arrow" role="presentation">
                  <b role="presentation"> </b>
                </span>
              </div>
              <div className="form-group text-start">
                <label>Role</label>
                <select
                  name="role"
                  className="form-control card-input select"
                  required
                  defaultValue=""
                  disabled={teamSelected ? false : true}
                >
                  <option disabled value="">
                    {" "}
                    -- select an option --{" "}
                  </option>
                  {teamSelected ? handleGetRoles() : null}
                </select>
                <span className="select2-selection__arrow" role="presentation">
                  <b role="presentation"> </b>
                </span>
              </div>
              <div className="form-group text-start">
                <label>Email</label>
                <input
                  className="form-control card-input"
                  placeholder="Enter your email"
                  type="email"
                  required
                  defaultValue={email}
                />
                <span className="error-text">Enter a valid email address</span>
              </div>
              <div className="form-group text-start">
              {/* Honeypot form fields */}
              <label 
                className="invisible-input"
              >
                Employment Type
              </label>
              <input
                  name={'honey'}
                  ref={honeypotRef}
                  type="hidden"
                  className="invisible-input form-control card-input"
                  placeholder="Enter employment type"
                />
                {/* Honeypot form fields */}
              </div>
              <div className="form-group text-start">
                {/* {console.log("In browser1: isSsoLogin:", isSsoLogin)} */}
                {isSsoLogin ? (
                  <input
                    className="form-control card-input hide-input"
                    placeholder="Enter your password"
                    type="password"
                    defaultValue="sso"
                    required
                  />
                ) : (
                  <>
                    <label>Password</label>
                    <input
                      className="form-control card-input"
                      placeholder="Enter your password"
                      type="password"
                      required
                    />
                  </>
                )}
              </div>
              <div className="form-group text-start">
                {console.log("In browser2: isSsoLogin:", isSsoLogin)}
                {isSsoLogin ? (
                  <input
                    className="form-control card-input hide-input"
                    placeholder="Enter your password"
                    type="password"
                    defaultValue="sso"
                    required
                  />
                ) : (
                  <>
                    <label>Confirm password</label>
                    <input
                      className="form-control card-input"
                      placeholder="Enter your password"
                      type="password"
                      required
                    />
                  </>
                )}
              </div>
              <span
                className="error-text global-error-text"
                ref={passwordValidationRef}
              >
                Make sure passwords match
              </span>

              <SpinnerButton loading={loadingState} buttonText="Sign Up" />
            </form>
            <div className="text-start mt-5 ms-0">
              <p className="mb-0">
                Already have an account? <Link to="/sign-in">Sign In</Link>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
   </>
  );
};

const mapStateToProps = ({}) => ({});

const mapDispatchToProps = (dispatch) => ({
  signUp: (user) => dispatch(signUp(user)),
  toastMessage: (data) => dispatch(toastMessage(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
